import type { AddressAutofillRetrieveResponse } from "@mapbox/search-js-core";

import { isValidCoordinatePair } from "@/features/location-management/utils/shared/coordinates";
import {
	mapAutofillFeatureToAddress,
	type ReverseGeocodeAddress,
} from "@/utils/reverse-geocode";

export type AddressAutofillFormValues = ReverseGeocodeAddress & {
	coordinates?: [number, number];
};

/** Maps a Mapbox Address Autofill retrieve response into location form fields. */
export const mapAddressAutofillRetrieveToForm = (
	response: AddressAutofillRetrieveResponse,
): AddressAutofillFormValues => {
	const feature = response.features?.[0];
	if (!feature) {
		return {};
	}

	const coordinates =
		feature.geometry?.type === "Point" &&
		isValidCoordinatePair(feature.geometry.coordinates)
			? feature.geometry.coordinates
			: undefined;

	const address = mapAutofillFeatureToAddress(
		feature as NonNullable<Parameters<typeof mapAutofillFeatureToAddress>[0]>,
	);

	return {
		...address,
		coordinates,
	};
};
